import React from 'react';

function EmptyComponent() {
  return null;
}

export default EmptyComponent;
